import React from "react";
import PublicLayout from "../../components/PublicLayout";
import {
  Users, CreditCard, Inbox, BellRing, FileBarChart2, ShieldCheck, UploadCloud, ListChecks, Wallet,
} from "lucide-react";

const FEATURES = [
  {
    icon: Users,
    title: "Rosters without spreadsheets",
    body: "Create teams, add players, attach parent contacts. Send invite links and parents join themselves.",
  },
  {
    icon: CreditCard,
    title: "Any kind of fee",
    body: "Monthly dues, uniform, tournament, fundraiser, training session, or a custom fee. Assign to whole team or specific players.",
  },
  {
    icon: UploadCloud,
    title: "Mark-as-paid with receipts",
    body: "Parents pick how they paid — Venmo, Zelle, Cash App, cash, check — add a note, upload a screenshot.",
  },
  {
    icon: Inbox,
    title: "Payment review queue",
    body: "One screen with every payment awaiting your confirmation. Confirm, ask for a resubmit, or waive in a tap.",
  },
  {
    icon: BellRing,
    title: "Reminders that do the awkward for you",
    body: "Send email reminders to a single parent, a selection, or everyone still unpaid on a fee.",
  },
  {
    icon: Wallet,
    title: "Parent view is simple",
    body: "Parents see exactly what they owe, when it’s due, and your preferred payment instructions.",
  },
  {
    icon: FileBarChart2,
    title: "Reports + CSV export",
    body: "Filter by team, fee, player, status, or due date. Export to CSV for your accountant.",
  },
  {
    icon: ListChecks,
    title: "Built for phones",
    body: "Coaches live on their phones. Big tap targets, clean status badges, no UI overhead.",
  },
];

export default function Features() {
  return (
    <PublicLayout>
      <section className="container-page py-16 md:py-20">
        <p className="label-caps">Features</p>
        <h1 className="h1 mt-2 max-w-3xl">Everything you need. Nothing you don’t.</h1>
        <p className="mt-4 max-w-2xl text-lg text-ink-700">
          Squad Fee is deliberately small. We don’t process payments, we don’t sell merch,
          we don’t integrate with 47 platforms. We help you collect dues.
        </p>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(({ icon: Icon, title, body }) => (
            <div key={title} className="rounded-xl border border-ink-100 bg-white p-6 shadow-sm card-hover">
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-brand-50 text-brand">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="h3 mt-4">{title}</h3>
              <p className="mt-2 text-sm text-ink-500">{body}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-2xl border border-ink-100 bg-ink-900 p-10 text-white">
          <div className="flex items-center gap-3">
            <ShieldCheck className="h-7 w-7 text-brand" />
            <h2 className="font-heading text-2xl font-bold">Why no card processing?</h2>
          </div>
          <p className="mt-3 max-w-2xl text-ink-300">
            Payment processing means KYC, tax forms, surprise chargebacks, and fees. Most coaches are getting paid on Venmo or Zelle already.
            We just help you see who did it and who hasn’t. Simpler for you, free for parents.
          </p>
        </div>
      </section>
    </PublicLayout>
  );
}
